import { AccessTimeRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from 'react';

const AryCountDownCounter = forwardRef(
  ({ initialTimeInSeconds, onTimeOut, hidden }, ref) => {
    const theme = useTheme();

    const intervalId = useRef(null);
    const [time, setTime] = useState(initialTimeInSeconds);

    function parseTime(timeInSecond) {
      const minutes = Math.floor(timeInSecond / 60);
      const seconds = timeInSecond % 60;
      return `${minutes < 10 ? `0${minutes}` : minutes}:${
        seconds < 10 ? `0${seconds}` : seconds
      }`;
    }

    function resetTime() {
      setTime(initialTimeInSeconds);
      intervalId.current = setInterval(() => {
        setTime((prevTime) => prevTime - 1);
      }, 1000);
    }

    useEffect(() => {
      (async () => {
        if (time === 0 && intervalId.current) {
          clearInterval(intervalId.current);
          intervalId.current = null;
          await onTimeOut();
        }
      })();
    }, [time]);

    useEffect(
      () => () => {
        if (intervalId.current) {
          clearInterval(intervalId.current);
          intervalId.current = null;
        }
      },
      []
    );

    useImperativeHandle(ref, () => ({
      resetTime() {
        resetTime();
      }
    }));

    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        spacing={theme.margin.twoTypographyHorizontal}
        sx={{ display: hidden ? 'none' : 'flex' }}
      >
        <AccessTimeRounded color="secondary" />
        <Typography variant="h6Bold" color="secondary" width="30px">
          {parseTime(time)}
        </Typography>
      </Stack>
    );
  }
);

export default AryCountDownCounter;
